import { AudioDeviceInfo, VideoDeviceInfo } from "@azure/communication-calling";
import { IDropdownOption } from "@fluentui/react";

export const getDevicesAsDropdownList = (list: Array<VideoDeviceInfo | AudioDeviceInfo>): IDropdownOption[] => {
    // Remove duplicates
    const noDuplicates = new Map<string, VideoDeviceInfo | AudioDeviceInfo>();
    for (const item of list) {
        noDuplicates.set(item.id, item);
    }
    const dropdownList: IDropdownOption[] = [];
    for (const item of noDuplicates.values()) {
        dropdownList.push({
            key: item.id,
            text: item.name === '' ? item.deviceType : item.name
        });
    }
    return dropdownList;
};
